import { useEffect, useRef, useState } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from 'moment';
import { useGetReferralLevel } from './UserDetailapi';
import { Search, ArrowUp, ArrowDown, Copy, Check } from 'lucide-react';
import { useDebounce } from '../../hooks/debounce';
import { useNavigate, useParams } from 'react-router-dom';
import { copyToClipboard } from '../../lib/copytoClipboard';
import { useModalContext } from '../../contexts/ModalContext';
import { useToast } from '../../hooks/usetoast';
import BreadcrumbPagination from '../../utils/BreadcrumbPagination';
import { useBreadcrumbPagination } from '../../hooks/useBreadcrumbPagination';

function SingleUserReferralHistory() {
    const [tempPage, setTempPage] = useState(1);
    const [tempRows, setTempRows] = useState(10);
    const [search, setSearch] = useState("");
    const [sortOrder, setSortOrder] = useState("desc")
    const [filterType, setFilterType] = useState("all")
    const [selectedLevel, setSelectedLevel] = useState("");
    const [email, setEmail] = useState(false);
    const [referId, setReferId] = useState(false)
    const searchText = useDebounce(search);
    const { id, level } = useParams();
    const { theme } = useModalContext()
    const toast = useToast();
    const navigate = useNavigate();
    const inputRef = useRef(null);

    useEffect(() => {
        if (level !== undefined) {
            setSelectedLevel(level);
            setFilterType("Level");
        }
    }, [level]);

    const { data: getReferralHistory, isLoading } = useGetReferralLevel({
        id,
        userId: id,
        page: searchText ? 1 : Math.max(tempPage, 1),
        searchText,
        level: filterType === "Level" ? selectedLevel : undefined,
        type: filterType,
        sortField: "createdAt",
        limit: tempRows,
        sortOrder: sortOrder
    })




    const totalRecords = getReferralHistory?.data?.total || 0;

    const {
        page,
        rowsPerPage,
        totalPages,
        handleChangePage,
        handleChangeRowsPerPage
    } = useBreadcrumbPagination(totalRecords, tempRows);

    useEffect(() => {
        setTempPage(Math.max(page, 1));
    }, [page]);

    useEffect(() => {
        setTempRows(rowsPerPage);
    }, [rowsPerPage]);

    useEffect(() => {
        setTempPage(0);
        if (handleChangePage) {
            handleChangePage(null, 0);
        }
    }, [searchText]);






    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
            const length = inputRef.current.value.length;
            inputRef.current.setSelectionRange(length, length);
        }
    });

    const copyEmailAddress = async data => {
        setEmail(data._id)
        await copyToClipboard(data?.email)
        toast.success("Email copied")
        setTimeout(() => {
            setEmail()
        }, 800)
    }

    const copyReferId = async data => {
        setReferId(data._id)
        await copyToClipboard(data?.referralId)
        toast.success("Copied")
        setTimeout(() => {
            setReferId()
        }, 800)
    }


    const renderReferralHistoryTable = () => (
        getReferralHistory?.data?.data?.length > 0 ? (
            <>
                <div style={{ minHeight: "60vh" }}>
                    <div className='table-responsive'>
                        <Table sx={{ minWidth: 650 }} aria-label="user history table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className='text-nowrap' align="center">S.NO</TableCell>
                                    <TableCell className='text-nowrap' align="center">Type</TableCell>
                                    <TableCell className='text-nowrap' align="center">Username</TableCell>
                                    <TableCell className='text-nowrap' align="center">email</TableCell>
                                    <TableCell className='text-nowrap' align="center">Referral ID</TableCell>
                                    <TableCell className='text-nowrap' align="center">Referral Count</TableCell>
                                    <TableCell className='text-nowrap'>Date and Time {sortOrder !== "desc" ? <ArrowUp onClick={() => setSortOrder(' desc')} style={{ cursor: "pointer" }} /> : <ArrowDown onClick={() => setSortOrder('asc')} style={{ cursor: "pointer" }} />}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {getReferralHistory?.data?.data?.map((row, i) => (
                                    <TableRow key={row._id || i}>
                                        <TableCell className='text-nowrap' align="center">{page * rowsPerPage + (i + 1)}</TableCell>
                                        <TableCell className='text-nowrap' align="center">
                                            {row?.level + 1 === 1 ? "Direct" : `Level ${row?.level + 1}`}
                                        </TableCell>
                                        <TableCell className='text-nowrap' align="center">{row?.userName || "-"}</TableCell>
                                        <TableCell align="center">
                                            {row?.email || "-"}
                                            {email === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyEmailAddress(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell className='text-nowrap' align="center">
                                            {row?.referralId || "-"}
                                            {referId === row._id ? (
                                                <Check size={20} style={{ marginLeft: "5px", color: theme ? "white" : 'black' }} />
                                            ) : (
                                                <Copy
                                                    onClick={() => copyReferId(row)}
                                                    size={20}
                                                    className='ml-5'
                                                    style={{ cursor: "pointer", marginLeft: "5px", color: theme ? "white" : 'black' }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell className='text-nowrap' align="center">{row?.userRefCount || "-"}</TableCell>
                                        <TableCell className='text-nowrap'>
                                            {moment(row?.createdAt).format("DD-MM-YYYY | hh:mm A")}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>
                <BreadcrumbPagination
                    page={page}
                    rowsPerPage={rowsPerPage}
                    totalPages={totalPages}
                    totalRecords={totalRecords}
                    handleChangePage={handleChangePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </>
        ) : (
            <NoRecords />
        )
    );


    return (
        <section>
            <h4>Single User Referral History</h4>
            <div className="ad_pg_bx bg-white p-3">
                <div className='d-flex justify-content-between align-items-center mb-2'>
                    <div className='col-md-4'>
                        <div className="input-group">
                            <span className="input-group-icon">
                                <Search size={20} color='#aaa9a9' />
                            </span>
                            <input
                                type="text"
                                ref={inputRef}
                                onChange={(e) => setSearch(e.target.value)}
                                className="form-control"
                                placeholder="Search Name"
                            />
                        </div>
                    </div>
                    <div className='d-flex col-md-4 justify-content-end'>
                        <select
                            className="form-select me-2"
                            value={selectedLevel}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSelectedLevel(value);
                                setFilterType(value === "" ? "all" : "Level");
                                setTempPage(1);
                            }}
                        >
                            <option value="">All Levels</option>
                            {[...Array(10)].map((_, i) => {
                                const apiLevel = i;
                                const displayLevel = apiLevel + 1;
                                return (
                                    <option key={apiLevel} value={apiLevel}>
                                        {displayLevel === 1 ? "Direct" : `Level ${displayLevel}`}
                                    </option>
                                );
                            })}
                        </select>

                        <button
                            className="btn btn-outline-secondary"
                            onClick={() => {
                                setSearch("");
                                setFilterType("all")
                                setSelectedLevel("");
                                if (inputRef.current) inputRef.current.value = "";
                            }}
                        >
                            Clear Filters
                        </button>
                        <button
                            className="btn btn-outline-primary ms-2"
                            onClick={() => {
                                navigate(`/SingleUserHistory/${id}`, { state: { lastActiveTab: "Referral" } });
                            }}
                        >
                            Back
                        </button>
                    </div>
                </div>
                {(searchText || selectedLevel) && (
                    <div className="mb-2">
                        <strong>Active Filters:</strong>
                        {searchText && <span className="badge bg-primary ms-2">Search: {searchText}</span>}
                        {selectedLevel && (
                            <span className="badge bg-success ms-2">
                                {parseInt(selectedLevel) + 1 === 1
                                    ? "Direct"
                                    : `Level ${parseInt(selectedLevel) + 1}`}
                            </span>
                        )}
                    </div>
                )}
                {isLoading ?
                    <PageLoader />
                    :
                    renderReferralHistoryTable()
                }
            </div>
        </section>
    )
}

export default SingleUserReferralHistory